import { makeStyles } from '@mui/styles'
import React, { Fragment, useEffect, useState } from 'react'
import { Button, Chip, Grid, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import { GenericTable } from '../../_EOS/Table/GenericTable'
import { TableHeaderConfigWithType } from '../../_EOS/Table'
import { usePagination } from '../../../hooks/usePagination'
import { useApi } from '../../../hooks/useApi'
import { ApiResponse } from '../../../typings/ApiResponse'
import { getPickingRouteRelated } from '../api'
import { Status } from '../../../hooks/useFetchState'
import { ePickingRouteStates, ePickingRouteValidationState } from '../api/types'
import InfoIcon from '@mui/icons-material/Info'
import { Modal } from '../../_EOS/Modal'
import { useModal } from '../../../hooks/useModal'
import { Labeltemp } from '../PickingFinish/LabelTemp/LabelTemp'
import { LoadingButton } from '../../_EOS/Button/LoadingButton'

export interface PickingRoutesRelated {
  pickingRouteId: number
  lpn: string
  pickingRouteStateId: number
  validationStatusId: number
  zoneId: number
  zoneName: string
}

interface PickingRouteRelatedProps {
  pickingRouteId: number
  handleStartPickingRoute: (field?: string, value?: string) => void
  handlePageChange: (updatePage: number) => void
  PickingRouteStateFindedValidated: boolean // indica si la ruta picking principal esta validada.
  hasMultipleUnvalidatedRoutes: boolean
}

export const pickingRouteTableHeaderConfig = () => {
  const table: TableHeaderConfigWithType<PickingRoutesRelated>[] = [
    {
      field: 'pickingRouteId',
      title: 'Ruta de Picking',
      sortable: false
    },
    { field: 'lpn', title: 'LPN', sortable: false },
    { field: 'zoneName', title: 'Zona', sortable: false },
    {
      field: 'pickingRouteStateId',
      title: 'Estado Picking',
      formater: (_pickingRouteId: number | string, row) =>
        renderPickingRouteStateId(row!)
    },
    {
      field: 'ValidationStatusId',
      title: 'Estado Validación',
      formater: (_pickingRouteId: number | string, row) =>
        renderValidationStatusId(row!)
    }
  ]

  return table
}

const renderPickingRouteStateId = (
  pickingrouterelated: PickingRoutesRelated
) => {
  const { validationStatusId, pickingRouteStateId } = pickingrouterelated
  const enValidacion = 2
  const validada = 3

  if (validationStatusId !== validada) {
    switch (pickingRouteStateId) {
      case ePickingRouteStates.Creada:
        return <Typography>Creada</Typography>
      case ePickingRouteStates.Iniciada:
        return <Typography>Picking Iniciado</Typography>
      case ePickingRouteStates.Finalizada:
        return <Typography>Picking Finalizado</Typography>
      default:
        break
    }
  }

  if (pickingRouteStateId === ePickingRouteStates.Finalizada) {
    switch (validationStatusId) {
      case enValidacion:
        return <Typography>En validación</Typography>
      case validada:
        return <Typography>Validada</Typography>
    }
  }

  return <Typography>Sin estado</Typography>
}

const renderValidationStatusId = (
  pickingrouterelated: PickingRoutesRelated
) => {
  const { validationStatusId } = pickingrouterelated

  switch (validationStatusId) {
    case ePickingRouteValidationState.Validada:
      return (
        <Chip
          label='VALIDADA'
          style={{
            backgroundColor: '#4caf50',
            color: 'white',
            fontWeight: 'bold',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
          }}
        />
      )
    case ePickingRouteValidationState.NoValidada:
      return (
        <Chip
          label='NO VALIDADA'
          style={{
            backgroundColor: 'yellow',
            color: 'black',
            fontWeight: 'bold',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)'
          }}
        />
      )
    default:
      return (
        <Typography>
          Estado no reconocido: {pickingrouterelated.validationStatusId}
        </Typography>
      )
  }
}

const useStyles = makeStyles({
  smallTextButton: {
    fontSize: '0.7rem', // o el tamaño que necesites
    padding: '4px 8px'
  },
  buttonActionCustom: {
    whiteSpace: 'nowrap', // Evita saltos de línea
    overflow: 'hidden', // Oculta contenido extra
    textOverflow: 'ellipsis', // Agrega "..." si se recorta
    height: 40, // Altura del botón
    padding: '0 16px', // Espaciado horizontal
    textTransform: 'none' // Mantiene el texto como lo escribes
  }
})
export const PickingRouteRelated: React.FC<PickingRouteRelatedProps> = ({
  pickingRouteId,
  handleStartPickingRoute,
  hasMultipleUnvalidatedRoutes
}) => {
  // Etiqueta Temporal
  const [selectedPickingRouteId, setSelectedPickingRouteId] =
    useState<number>(0) // pickingRouteId seleccionada en la grilla de rutas relacionadas

  const {
    isOpen: isOpenModalLabelTemp,
    closeModal: CloseLabelTemp,
    openModal: openModalLabelTemp
  } = useModal('')

  const [allRoutesPickingFinalize, setAllRoutesPickingFinalize] =
    useState<boolean>(false)
  const { state, callApi } = useApi<ApiResponse<PickingRoutesRelated>>()
  const configsHeaders = pickingRouteTableHeaderConfig()
  const classes = useStyles()
  const [loadingButtonGrid, setLoadingButtonGrid] = useState(false)
  const pagination = usePagination(10)

  const requestPickingRouteRelated = (page?: number, pageSize?: number) => {
    callApi(getPickingRouteRelated(pickingRouteId, page, pageSize)).catch(
      (error) => {
        console.log(error)
      }
    )
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    requestPickingRouteRelated(auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  const handleValidateRouteRelated = (pickingRouteId: number) => {
    handleStartPickingRoute('pickingRouteId', pickingRouteId.toString())
  }

  const handleShowLabelTempPickingRouteRelated = (pickingRouteId: number) => {
    setSelectedPickingRouteId(pickingRouteId)
    openModalLabelTemp()
  }

  const handleCloseLabelTempPickingRouteRelated = () => {
    setSelectedPickingRouteId(0)
    CloseLabelTemp()
  }

  // metodo que identifica si las rutas relacionadas y la principal estan finalizadas para bloquear boton
  const handleValidateAllFinalized = () => {
    // Nota historia:
    // 1-si estan todas las rutas validadas se debe bloquear boton temporal
    // 2-si todas las rutas estan validadas y la etiqueta courier está. debe bloquear boton temporal

    // evalua en caso no tener rutas relacionadas retorna true (bloquea)
    if (!existRelatedRoutes()) {
      return true
    }

    // !hasMultipleUnvalidatedRoute: Se obtiene valor en PickingLabelActions.tsx se usa misma logica que en PickingUsingExternalCourierLabel.tsx para bloquear boton Etiqueta temporal
    return !hasMultipleUnvalidatedRoutes
  }

  type CustomActionsProps = {
    id: number
    row: PickingRoutesRelated
  }

  const handleValidateRouteRelatedLoaging = (pickingRouteId: number) => {
    setLoadingButtonGrid(true)
    handleValidateRouteRelated(pickingRouteId)
  }

  // se agrega hasMultipleUnvalidatedRoutes debido al caso en que 2 rutas relacionadas pueden estar validada pero no ha llegado la etiqueta courier.
  const MyCustomActions: React.FC<CustomActionsProps> = ({ row }) => {
    switch (row.validationStatusId) {
      case ePickingRouteValidationState.Validada:
        return (
          <Button
            disabled={handleValidateAllFinalized()}
            type='button'
            className={classes.buttonActionCustom}
            variant='contained'
            color='primary'
            onClick={() =>
              handleShowLabelTempPickingRouteRelated(row.pickingRouteId)
            }
          >
            Generar etiqueta provisoria
          </Button>
        )
      case ePickingRouteValidationState.NoValidada:
        return (
          <LoadingButton
            type='button'
            className={classes.buttonActionCustom}
            variant='contained'
            color='primary'
            fullWidth
            onClick={() =>
              handleValidateRouteRelatedLoaging(row.pickingRouteId)
            }
            loading={loadingButtonGrid}
          >
            Validar Ruta
          </LoadingButton>
        )
      default:
        return (
          <Typography>
            Estado no reconocido: {row.validationStatusId}
          </Typography>
        )
    }
  }

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)
    requestPickingRouteRelated(0, pagination.pageSize)
  }, [])

  const existRelatedRoutes = () => {
    if (state.data?.items !== undefined && state.data?.totalItems > 0)
      return true

    return false
  }

  useEffect(() => {
    // Evita errores si state.data o items está vacío o nulo
    const items = state.data && state.data.items ? state.data.items : []
    // Verifica que todos los registros tengan pickingRouteStateId === 3
    const allRoutesPickingFinalizeRequest =
      items.length > 0 && items.every((item) => item.pickingRouteStateId === 3)

    // Verifica que todos los registros tengan validationStatusId === 3
    const allValidationStatus =
      items.length > 0 && items.every((item) => item.validationStatusId === 3)

    // Solo será true si ambas condiciones se cumplen
    const allRoutesRelatedValidated =
      allRoutesPickingFinalizeRequest && allValidationStatus

    // Setea el valor final (true solo si ambas condiciones se cumplen)
    setAllRoutesPickingFinalize(allRoutesRelatedValidated)
    setLoadingButtonGrid(false)
  }, [state])

  return (
    <Fragment>
      {existRelatedRoutes() && (
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Typography variant='body1' style={{ fontWeight: 'bold' }}>
              Rutas Relacionadas:
            </Typography>
          </Grid>
          <Grid item>
            {allRoutesPickingFinalize && existRelatedRoutes() && (
              <Typography
                variant='body1'
                align='right'
                style={{ color: 'orange' }}
              >
                <InfoIcon /> Asegúrese de reunir las rutas validadas antes de
                generar la etiqueta del transportista
              </Typography>
            )}

            {!allRoutesPickingFinalize && (
              <Typography
                variant='body1'
                align='right'
                style={{ color: 'orange' }}
              >
                <WarningIcon /> NO se puede generar la etiqueta si no se tienen
                todas las rutas validadas
              </Typography>
            )}
          </Grid>
        </Grid>
      )}
      {state.data?.items !== undefined && state.data?.items.length >= 1 && (
        <GenericTable<PickingRoutesRelated>
          dense={true}
          headersConfig={configsHeaders}
          IDKey={'pickingRouteId'}
          data={state.data?.items}
          pagination={{
            totalItem: state.data?.totalItems || 0,
            page: pagination.page,
            pageSize: pagination.pageSize
          }}
          onPaginationChange={handlePaginationChange}
          isLoading={state.status === Status.Loading}
          customActionComponent={MyCustomActions}
        />
      )}
      <Modal
        title={'Etiqueta temporal'}
        onClose={handleCloseLabelTempPickingRouteRelated}
        open={isOpenModalLabelTemp}
        maxWidth='lg'
      >
        <Labeltemp pickingRouteId={selectedPickingRouteId} />
      </Modal>
    </Fragment>
  )
}
